import { EventRegistrationPreviewComponent } from './EventRegistrationPreview.Component';

export const EventRegistrationPreviewDialog = 'EventRegistrationPreview';


export const dialogCfg = [{
	name: EventRegistrationPreviewDialog,
	component: EventRegistrationPreviewComponent
}];
